export const en = {
    "are_you_facility": "",
    "access": "",
    "register": "",
    "welcome": "",
    "popular_courts": "",
    "our_strong_points": "",
    "about_us": "",
    "session_refreshed": "Session automatically refreshed"
}